// Global toast defaults — imported once by App.tsx before anything renders.
//
// Error toasts stay on screen until dismissed (owner request 2026-08-18,
// reaffirmed 2026-09-02): they carry the diagnostic the user needs to act on
// (RPC error text, validation failures) and the 1.5s container default made
// them unreadable.
//
// The house entry point is now `showErrorToast` in ./errorToast.tsx (sticky,
// copy icon, keyed dismissal) and every call site in the app uses it. This
// wrapper around react-toastify's own `toast.error` stays as the safety net
// for any future stray `toast.error(...)`: sticky (autoClose: false) with the
// standard ✕ close button. A call site passing its own autoClose still wins
// here — which is exactly why the call sites moved to showErrorToast, where
// the owner rule cannot be overridden by a stale TOAST_CONFIG.
//
// Success / info / warning toasts keep the fast auto-close defaults from
// FormTable/constants.ts (TOAST_AUTO_CLOSE).

import { toast, type ToastOptions } from 'react-toastify'

const baseError = toast.error.bind(toast)

const stickyError = ((content: unknown, options?: ToastOptions) =>
  baseError(content as never, {
    autoClose: false,
    closeButton: true,
    ...options
  })) as typeof toast.error

toast.error = stickyError

export {}
